import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { singleParagraphRevealAnimation } from './animations'
import { cn } from '@/lib/utils'

export type SingleParagraphProps = {
  paragraph: string
}

const SingleParagraph = ({ paragraph }: SingleParagraphProps) => {
  return (
    <Motion animation={singleParagraphRevealAnimation}>
      {(motionRef) => (
        <Section ref={motionRef} className="mb-spacing-lg lg:mb-0">
          <Grid>
            <div
              className={cn([
                'col-span-2 md:col-span-4 md:col-start-2',
                'lg:col-auto lg:row-span-8 lg:row-start-3 lg:w-col-span-3',
                'grid items-end'
              ])}
            >
              <div className="flex lg:w-col-span-4">
                <Typography variant="regular" paragraph data-motion-paragraph>
                  {paragraph}
                </Typography>
              </div>
            </div>
          </Grid>
        </Section>
      )}
    </Motion>
  )
}

export default SingleParagraph
